module.exports = __webpack_public_path__ + "img/67.692d2e15.jpg";